import styled from 'styled-components'

export const UploadSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`
